import { AxiosResponse } from 'axios';
import cookie from 'react-cookies';
import { SetterOrUpdater } from 'recoil';
import axios from '../../common/axiosInterceptor';
import { ACCESS_TOKEN_COOKIE_EXPIRE_MS } from '../../constants';
export interface ILoginAjaxReturn {
  success: boolean;
  loginUser?: any;
  error?: any;
  captchaRequired?: boolean;
}
interface ILoginAjax {
  /** Credentials from form */
  credentials: {
    email: string;
    password: string;
    token?: string;
  };
  /** Recoil setter for user atom */
  setUserAtom: SetterOrUpdater<any>;
}

/**
 * Login using credentials and set user atom
 * @returns Response object with success, error and loginUser
 */
export const loginAjax = async ({
  credentials,
  setUserAtom,
}: ILoginAjax): Promise<ILoginAjaxReturn> => {
  try {
    const response: AxiosResponse<any> | undefined = await axios.post(
      `${process.env.VITE_APP_API_DOMAIN}/${process.env.VITE_APP_API_STAGE}/loginDash`,
      {
        json: credentials,
      }
    );
    const { success, result: loginUser, errorType: error } =
      response?.data || {};
    if (success) {
      const { accessToken, refreshToken } = loginUser;
      localStorage.setItem('user', JSON.stringify(loginUser));
      localStorage.setItem('refreshToken', refreshToken);
      cookie.save('accessToken', accessToken, {
        path: '/',
        expires: new Date(
          loginUser?.expiresInTimestamp ??
            Date.now() + ACCESS_TOKEN_COOKIE_EXPIRE_MS // set expiration to 30 mintues
        ),
      });
    } else {
      // clear localstorage/cookies
      localStorage.removeItem('user');
      localStorage.removeItem('refreshToken');
      // cookies since it can expire
      cookie.remove('accessToken', { path: '/' });
    }
    // set user atom
    setUserAtom(loginUser);
    return {
      success: !!success, // cast to boolean
      loginUser,
      error,
      captchaRequired: response?.data?.captchaRequired,
    };
  } catch (error) {
    // clear uesr atom on error
    setUserAtom({});
    return {
      success: false,
      error,
    };
  }
};
